module.exports = __webpack_public_path__ + "static/media/44493038_2199888756752970_8785936257776615424_o-thumb.5e8b45f2.jpg";